import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form } from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaTools, FaBoxes, FaCheck, FaArrowRight, FaArrowLeft, FaRedo, FaCog } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const Liste_produit = ({ titre }) => {
    useAuth()
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [selectedProduit, setSelectedProduit] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const location = useLocation();
    const [descriptionOverflows, setDescriptionOverflows] = useState({});
    const [isLoadingButton, setIsLoadingButton] = useState(false);


    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingAjout, setIsLoadingAjout] = useState(false);
    const [isLoadingModif, setIsLoadingModif] = useState(false);

    // États pour les modals
    const [showAjouterModal, setShowAjouterModal] = useState(false);
    const [showModifierModal, setShowModifierModal] = useState(false);
    const [showCodeModal, setShowCodeModal] = useState(false);

    // États pour les formulaires
    const [formData, setFormData] = useState({
        nom: '',
        description: '',
        prix: '',
        periode: '',
        photo: null
    });
    const [promoEndDate, setPromoEndDate] = useState('');
    const [promoPercentage, setPromoPercentage] = useState('');

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Produit";
        }
    }, [user_id]);

    const [produits, setProduits] = useState([]);
    const fetchProduits = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-produit/');
            if (response.ok) {
                const data = await response.json();
                setProduits(data);
            } else {
                console.error('Erreur lors de la récupération des produits');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false)
        }
    };

    useEffect(() => {
        fetchProduits();
    }, []);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            fetchProduits()
        }, 3000);
    };

    const handleRowClick = (produit) => {
        setSelectedProduit(produit);
    };

    const handleDeleteProduit = async () => {
        if (selectedProduit) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-produit/${selectedProduit.id}/`, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    setProduits(produits.filter((produit) => produit.id !== selectedProduit.id));
                    showAlert('Produit supprimé avec succès !');
                } else {
                    console.error('Erreur lors de la suppression du produit');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
                setSelectedProduit(null);
            }
        }
    };

    const checkDescriptionOverflow = (produits) => {
        produits.forEach((produit) => {
            const element = document.getElementById(`description-${produit.id}`);
            if (element) {
                setDescriptionOverflows((prev) => ({
                    ...prev,
                    [produit.id]: element.scrollHeight > element.clientHeight,
                }));
            }
        });
    };

    useEffect(() => {
        checkDescriptionOverflow(produits);
    }, [produits]);

    const handleShowDeleteModal = () => {
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleGenererCode = async () => {
        if (!promoEndDate || !promoPercentage) {
            showAlert('Veuillez remplir tous les champs', 'danger');
            return;
        }

        setIsLoadingButton(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/attribuer-code-produit/${selectedProduit.id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    date_fin: promoEndDate,
                    pourcentage: promoPercentage
                }),
            });
            const data = await response.json();

            if (response.ok) {
                showAlert(data.message, 'success');
                fetchProduits();
                setShowCodeModal(false);
                setPromoEndDate('');
                setPromoPercentage('');
            } else {
                showAlert(data.error, 'danger');
            }
        } catch (error) {
            console.error('Erreur lors de la génération du code:', error);
            showAlert(error.message, 'danger');
        } finally {
            setIsLoadingButton(false);
        }
    };

    // Fonctions pour les modals
    const handleOpenAjouterModal = () => {
        setFormData({
            nom: '',
            description: '',
            prix: '',
            periode: '',
            photo: null
        });
        setShowAjouterModal(true);
    };

    const handleCloseAjouterModal = () => {
        setShowAjouterModal(false);
        setFormData({
            nom: '',
            description: '',
            prix: '',
            periode: '',
            photo: null
        });
    };

    const handleOpenModifierModal = () => {
        if (selectedProduit) {
            setFormData({
                nom: selectedProduit.nom,
                description: selectedProduit.description,
                prix: selectedProduit.prix,
                periode: selectedProduit.periode,
                photo: null
            });
            setShowModifierModal(true);
        }
    };

    const handleCloseModifierModal = () => {
        setShowModifierModal(false);
        setFormData({
            nom: '',
            description: '',
            prix: '',
            periode: '',
            photo: null
        });
    };

    // Gestion des changements de formulaire
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleDescriptionChange = (value) => {
        setFormData(prev => ({
            ...prev,
            description: value
        }));
    };

    const handleFileChange = (e) => {
        setFormData(prev => ({
            ...prev,
            photo: e.target.files[0]
        }));
    };



    // Soumission du formulaire d'ajout
    const handleAjouterProduit = async (e) => {
        e.preventDefault();

        const submitFormData = new FormData();
        submitFormData.append('nom', formData.nom);
        submitFormData.append('description', formData.description);
        submitFormData.append('prix', formData.prix);
        submitFormData.append('periode', formData.periode);
        if (formData.photo) {
            submitFormData.append('photo', formData.photo);
        }

        setIsLoadingAjout(true)

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/ajouter-produit/${user_id}/`, {
                method: 'POST',
                body: submitFormData,
            });

            if (response.ok) {
                showAlert('Produit ajouté avec succès !');
                handleCloseAjouterModal();
                fetchProduits();
            } else {
                const errorData = await response.json();
                showAlert(errorData.error || 'Erreur lors de l\'ajout du produit', 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur réseau lors de l\'ajout du produit', 'danger');
        } finally {
            setIsLoadingAjout(false)
        }
    };

    // Soumission du formulaire de modification
    const handleModifierProduit = async (e) => {
        e.preventDefault();

        const submitFormData = new FormData();
        submitFormData.append('nom', formData.nom);
        submitFormData.append('description', formData.description);
        submitFormData.append('prix', formData.prix);
        submitFormData.append('periode', formData.periode);
        if (formData.photo) {
            submitFormData.append('photo', formData.photo);
        }

        setIsLoadingModif(true)

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-produit/${selectedProduit.id}/`, {
                method: 'POST',
                body: submitFormData,
            });

            if (response.ok) {
                showAlert('Produit modifié avec succès !');
                handleCloseModifierModal();
                fetchProduits();
            } else {
                const errorData = await response.json();
                showAlert(errorData.error || 'Erreur lors de la modification du produit', 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur réseau lors de la modification du produit', 'danger');
        } finally {
            setIsLoadingModif(false)
        }
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean'],
            [{ 'align': [] }],
        ],
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    // Filtrage et tri
    const filteredProduits = produits.filter(produit =>
        produit.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
        produit.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        produit.ajoute_par.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (produit.code_produit && produit.code_produit.toLowerCase().includes(searchTerm.toLowerCase())) ||
        produit.print.toString().includes(searchTerm.toLowerCase()) ||
        produit.periode.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedProduits = [...filteredProduits].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handleToggleDescription = (id) => {
        setExpandedDescriptions((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    // Pagination
    const indexOfLastProduct = currentPage * itemsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
    const currentProducts = sortedProduits.slice(indexOfFirstProduct, indexOfLastProduct);
    const totalPages = Math.ceil(sortedProduits.length / itemsPerPage);
    const totalItems = produits.length;

    if (!accesGroupe.includes("Produits")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaBoxes size={25} className='mr-2' /> Gestion des Produits</h2>
                            <small>Administration des produits.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-produit`}> Produits</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="mt-3 wrapper wrapper-content animated fadeInRight">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                            <h5>Liste des produits</h5>
                            <div className="d-flex mt-3 mt-md-0" style={{ gap: '10px' }}>
                                <button
                                    onClick={handleOpenAjouterModal}
                                    className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                >
                                    <FaPlus />
                                    <span className="d-none d-sm-inline ml-2">
                                        Ajouter produit
                                    </span>
                                </button>
                                <button
                                    onClick={handleOpenModifierModal}
                                    className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedProduit ? 'btn-success' : 'btn-default text-dark'}`}
                                    disabled={!selectedProduit}
                                >
                                    <FaEdit />
                                    <span className="d-none d-sm-inline ml-2">
                                        Modifier
                                    </span>
                                </button>
                                {/* {isLoadingButton ? (
                                    <button className="btn btn-success mr-2" disabled>
                                        <i className="fa fa-spinner fa-spin mr-1"></i>
                                        <span className="d-none d-sm-inline ml-2">
                                            Chargement...
                                        </span>
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => setShowCodeModal(true)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedProduit ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedProduit}
                                    >
                                        {selectedProduit?.code_produit ? (<FaRedo />) : (<FaCog />)}
                                        <span className="d-none d-sm-inline ml-1">
                                            {selectedProduit?.code_produit ? 'Réinitialiser' : 'Générer code'}
                                        </span>
                                    </button>
                                )} */}

                                <button
                                    onClick={handleShowDeleteModal}
                                    className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedProduit ? 'btn-success' : 'btn-default text-dark'}`}
                                    disabled={!selectedProduit}
                                >
                                    <FaTrash />
                                    <span className="d-none d-sm-inline ml-2">
                                        Supprimer
                                    </span>
                                </button>
                            </div>
                        </div>

                        {alert.message && (
                            <div className={`alert alert-${alert.type}`}>
                                {alert.message}
                            </div>
                        )}

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <select
                                                id="itemsPerPage"
                                                value={itemsPerPage}
                                                onChange={(e) => {
                                                    setItemsPerPage(Number(e.target.value));
                                                    setCurrentPage(1);
                                                }}
                                                className="form-select bg-default p-1"
                                                style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                            </select>
                                            <input
                                                type="text"
                                                placeholder="Rechercher..."
                                                className="form-control"
                                                style={{ maxWidth: '150px', width: '100%' }}
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>
                                        <div className="table-responsive" style={{ fontSize: '11px' }}>
                                            <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                <thead>
                                                    <tr>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell" >
                                                            Image
                                                        </th>
                                                        <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('nom')} >
                                                            Nom
                                                            {sortConfig.key === 'nom'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('description')} >
                                                            Description {sortConfig.key === 'description'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('prix')} >
                                                            Prix {sortConfig.key === 'prix'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('ajoute_par')} >
                                                            Ajouté par {sortConfig.key === 'ajoute_par'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('periode')} >
                                                            Période {sortConfig.key === 'periode'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        {/* <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('code_produit')} >
                                                            Code promo {sortConfig.key === 'code_produit'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th> */}
                                                        {/* <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('date_fin_promo')} >
                                                            Date fin promo {sortConfig.key === 'date_fin_promo'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th> */}
                                                        {/* <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('pourcentage_promo')} >
                                                            Pourcentage promo {sortConfig.key === 'pourcentage_promo'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th> */}
                                                    </tr>
                                                </thead>

                                                {!isLoading ? (
                                                    <tbody>
                                                        {currentProducts.map((produit) => {
                                                            return (
                                                                <tr
                                                                    key={produit.id}
                                                                    onClick={() => handleRowClick(produit)}
                                                                    className={`bg-white ${selectedProduit && selectedProduit.id === produit.id ? 'bg-success text-white' : ''}`}
                                                                >
                                                                    <td>
                                                                        <img
                                                                            src={`${process.env.REACT_APP_HOTE}${produit.photo_url}`}
                                                                            alt={produit.nom}
                                                                            style={{
                                                                                width: '40px',
                                                                                height: '40px',
                                                                                objectFit: 'cover',
                                                                                borderRadius: '50%',
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        {produit.nom}
                                                                        <div className='lesInfos'>
                                                                            <small>Description : <small dangerouslySetInnerHTML={{ __html: produit.description }}></small></small><br />
                                                                            <small>Prix : {produit.prix} FCFA</small><br />
                                                                            <small>Ajouté par : {produit.ajoute_par}</small><br />
                                                                            <small>Période : {produit.periode}</small>
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell" style={{ position: 'relative' }}>
                                                                        <div
                                                                            id={`description-${produit.id}`}
                                                                            className={`description-text ${expandedDescriptions[produit.id] ? 'expanded' : ''}`}
                                                                            style={{
                                                                                maxHeight: expandedDescriptions[produit.id] ? 'none' : '3em',
                                                                                overflow: 'hidden',
                                                                                whiteSpace: 'pre-wrap',
                                                                            }}
                                                                            dangerouslySetInnerHTML={{ __html: produit.description }}
                                                                        />
                                                                        {descriptionOverflows[produit.id] && (
                                                                            <button onClick={() => handleToggleDescription(produit.id)} style={{
                                                                                background: 'none',
                                                                                border: 'none',
                                                                                color: 'black',
                                                                                cursor: 'pointer',
                                                                                padding: 0,
                                                                            }}>
                                                                                {expandedDescriptions[produit.id] ? 'Voir moins' : 'Voir plus...'}
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {produit.prix} FCFA
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {produit.ajoute_par}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {produit.periode ? `${produit.periode / 730} mois` : "Non spécifié"}
                                                                    </td>
                                                                    {/* <td className="d-none d-md-table-cell">
                                                                    {produit.code_produit}
                                                                </td> */}
                                                                    {/* <td className="d-none d-md-table-cell">
                                                                    {produit?.date_fin_promo ? new Date(produit?.date_fin_promo).toLocaleDateString() : ''}
                                                                </td> */}
                                                                    {/* <td className="d-none d-md-table-cell">
                                                                    {produit.pourcentage_promo ? `${produit.pourcentage_promo}%` : ''}
                                                                </td> */}
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan="8" className="text-center p-5">
                                                                <div className="d-flex justify-content-center align-items-center">
                                                                    <div className="spiner-example">
                                                                        <div className="sk-spinner sk-spinner-wave">
                                                                            <div className="sk-rect1 mr-1"></div>
                                                                            <div className="sk-rect2 mr-1"></div>
                                                                            <div className="sk-rect3 mr-1"></div>
                                                                            <div className="sk-rect4 mr-1"></div>
                                                                            <div className="sk-rect5"></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )}
                                            </table>
                                        </div>

                                        {/* Pagination Controls */}
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div className="dataTables_info" role="status" aria-live="polite">
                                                {totalItems === 0
                                                    ? "Aucun élément à afficher"
                                                    : `Élément ${indexOfFirstProduct + 1} à ${Math.min(indexOfLastProduct, totalItems)} sur ${totalItems}`}
                                            </div>
                                            <div>
                                                <button
                                                    onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                    className="btn btn-light mx-1"
                                                    disabled={currentPage === 1}
                                                >
                                                    <FaArrowLeft />
                                                </button>

                                                {(() => {
                                                    const pagesToShow = 5;
                                                    let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                    let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                    if (endPage - startPage < pagesToShow - 1) {
                                                        startPage = Math.max(1, endPage - pagesToShow + 1);
                                                    }

                                                    const pageButtons = [];

                                                    for (let i = startPage; i <= endPage; i++) {
                                                        pageButtons.push(
                                                            <button
                                                                key={i}
                                                                onClick={() => setCurrentPage(i)}
                                                                className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                            >
                                                                {i}
                                                            </button>
                                                        );
                                                    }

                                                    return pageButtons;
                                                })()}

                                                <button
                                                    onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                    className="btn btn-light mx-1"
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <FaArrowRight />
                                                </button>

                                                <button
                                                    onClick={() => setCurrentPage(totalPages)}
                                                    className="btn btn-light mx-1"
                                                    disabled={currentPage === totalPages}
                                                >
                                                    {totalPages}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Modal de confirmation de suppression */}
                        <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                            <Modal.Header>
                                <Modal.Title>Confirmer la Suppression</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Êtes-vous sûr de vouloir supprimer le produit <strong>{selectedProduit?.nom}</strong> ?
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                    Annuler
                                </Button>
                                <Button variant="success" onClick={handleDeleteProduit}>
                                    Supprimer
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* Modal pour générer le code promo */}
                        <Modal show={showCodeModal} onHide={() => setShowCodeModal(false)}>
                            <Modal.Header>
                                <Modal.Title>Créer un code promo</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Date de fin de la promotion</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={promoEndDate}
                                            onChange={(e) => setPromoEndDate(e.target.value)}
                                            min={new Date().toISOString().split('T')[0]}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Pourcentage de réduction</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="10"
                                            value={promoPercentage}
                                            onChange={(e) => setPromoPercentage(e.target.value)}
                                            min="1"
                                            max="100"
                                        />
                                    </Form.Group>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowCodeModal(false)}>
                                    Annuler
                                </Button>
                                <Button
                                    variant="success"
                                    onClick={handleGenererCode}
                                    disabled={isLoadingButton}
                                >
                                    {isLoadingButton ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            En cours...
                                        </>
                                    ) : 'Générer le code'}
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* Modal d'ajout de produit */}
                        <Modal show={showAjouterModal} onHide={handleCloseAjouterModal} size="lg">
                            <Modal.Header>
                                <Modal.Title>Nouveau Produit</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form onSubmit={handleAjouterProduit} encType="multipart/form-data">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nom*</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Entrez le nom"
                                            required
                                            name="nom"
                                            value={formData.nom}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Description*</Form.Label>
                                        <ReactQuill
                                            theme="snow"
                                            value={formData.description}
                                            onChange={handleDescriptionChange}
                                            modules={modules}
                                            style={{ height: '200px', marginBottom: '50px' }}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Prix*</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Entrez le Prix"
                                            required
                                            name="prix"
                                            value={formData.prix}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Période*</Form.Label>
                                        <Form.Select
                                            className='custom-select'
                                            name="periode"
                                            required
                                            value={formData.periode}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Sélectionner une période</option>
                                            {[...Array(12)].map((_, index) => {
                                                const mois = index + 1;
                                                const heures = mois * 730;
                                                return (
                                                    <option key={mois} value={heures}>
                                                        {mois} {mois === 1 ? "mois" : "mois"} ({heures} heures)
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Photo*</Form.Label>
                                        <Form.Control
                                            type="file"
                                            required
                                            name="photo"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                        />
                                    </Form.Group>
                                    <div className="text-center mt-4">
                                        <Button variant="secondary" onClick={handleCloseAjouterModal} className="mr-2">
                                            Annuler
                                        </Button>
                                        {isLoadingAjout ? (
                                            <button className="btn btn-success mr-2" disabled>
                                                <i className="fa fa-spinner fa-spin mr-1"></i>
                                                <span className="d-none d-sm-inline ml-2">
                                                    Chargement...
                                                </span>
                                            </button>
                                        ) : (
                                            <Button type="submit" variant="success">
                                                Enregistrer
                                            </Button>
                                        )}
                                    </div>
                                </Form>
                            </Modal.Body>
                        </Modal>

                        {/* Modal de modification de produit */}
                        <Modal show={showModifierModal} onHide={handleCloseModifierModal} size="lg">
                            <Modal.Header>
                                <Modal.Title>Modifier le Produit</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form onSubmit={handleModifierProduit} encType="multipart/form-data">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nom*</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Entrez le nom"
                                            required
                                            name="nom"
                                            value={formData.nom}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Description*</Form.Label>
                                        <ReactQuill
                                            theme="snow"
                                            value={formData.description}
                                            onChange={handleDescriptionChange}
                                            modules={modules}
                                            style={{ height: '200px', marginBottom: '50px' }}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Prix*</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Entrez le Prix"
                                            required
                                            name="prix"
                                            value={formData.prix}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Période*</Form.Label>
                                        <Form.Select
                                            className='custom-select'
                                            name="periode"
                                            required
                                            value={formData.periode}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Sélectionner une période</option>
                                            {[...Array(12)].map((_, index) => {
                                                const mois = index + 1;
                                                const heures = mois * 730;
                                                return (
                                                    <option key={mois} value={heures}>
                                                        {mois} {mois === 1 ? "mois" : "mois"} ({heures} heures)
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Photo</Form.Label>
                                        <Form.Control
                                            type="file"
                                            name="photo"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                        />
                                        <Form.Text className="text-muted">
                                            Laisser vide pour conserver l'image actuelle
                                        </Form.Text>
                                    </Form.Group>
                                    <div className="text-center mt-4">
                                        <Button variant="secondary" onClick={handleCloseModifierModal} className="mr-2">
                                            Annuler
                                        </Button>
                                        {isLoadingModif ? (
                                            <button className="btn btn-success mr-2" disabled>
                                                <i className="fa fa-spinner fa-spin mr-1"></i>
                                                <span className="d-none d-sm-inline ml-2">
                                                    Chargement...
                                                </span>
                                            </button>
                                        ) : (
                                            <Button type="submit" variant="success">
                                                Modifier
                                            </Button>
                                        )}
                                    </div>
                                </Form>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Liste_produit;